import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const BASE_URL = "https://filataexperience.com";

const meta = {
  "/": {
    title: "Filata — Live Mozzarella Experience | Luxury Weddings & Grand Events",
    desc: "Filata — the Live Mozzarella Experience. Fresh mozzarella and burrata, hand-pulled live by Italian maestri: élite show cooking for luxury weddings, grand events and five-star venues.",
  },
  "/live-mozzarella-experience": {
    title: "Filata — Live Mozzarella Experience | Luxury Weddings & Grand Events",
    desc: "Filata — the Live Mozzarella Experience. Fresh mozzarella and burrata, hand-pulled live by Italian maestri: élite show cooking for luxury weddings, grand events and five-star venues.",
  },
  "/events": {
    title: "Filata — Luxury Wedding & Grand Events | Live Mozzarella Show Cooking",
    desc: "Signature live mozzarella atelier and Grand Pentolo Show Cooking for luxury weddings, galas and five-star venues — an artistic add-on that completes your venue's catering.",
  },
  "/luxury-wedding-events-show-cooking": {
    title: "Filata — Luxury Wedding & Grand Events | Live Mozzarella Show Cooking",
    desc: "Signature live mozzarella atelier and Grand Pentolo Show Cooking for luxury weddings, galas and five-star venues — an artistic add-on that completes your venue's catering.",
  },
  "/v2": {
    title: "Filata — Live Mozzarella Experience | The Mediterranean Style",
    desc: "One warm evening under the stars: the casaro at work in the open air, warm steam rising from the pot — an intimate, timeless theatre of fresh mozzarella and burrata.",
  },
};

const setMeta = (selector, attr, value) => {
  const el = document.querySelector(selector);
  if (el) el.setAttribute(attr, value);
};

export const Seo = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    const m = meta[pathname.replace(/\/$/, "") || "/"];
    if (!m) return;
    document.title = m.title;
    setMeta('meta[name="description"]', "content", m.desc);
    setMeta('meta[property="og:title"]', "content", m.title);
    setMeta('meta[property="og:description"]', "content", m.desc);
    setMeta('meta[property="og:url"]', "content", `${BASE_URL}${pathname === "/" ? "/" : pathname}`);
    setMeta('meta[name="twitter:title"]', "content", m.title);
    setMeta('link[rel="canonical"]', "href", `${BASE_URL}${pathname === "/" ? "/" : pathname}`);
  }, [pathname]);
  return null;
};
